import React from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import "./styles/landing.scss";
import LandingHeader from "./components/LandingHeader";
import LandingFooter from "./components/LandingFooter";
import LandingPage from "./pages/LandingPage";
import PlatformPage from "./pages/PlatformPage";
import UseCasesPage from "./pages/UseCasesPage";
import ResourcesPage from "./pages/ResourcesPage";
import AboutPage from "./pages/AboutPage";
import WaitlistPage from "./pages/WaitlistPage";
import ToolsPage from "./pages/ToolsPage";
import BasecallingPage from "./pages/BasecallingPage";
import ClusteringPage from "./pages/ClusteringPage";
import ModificationDiscoveryPage from "./pages/ModificationDiscoveryPage";

const App = () => {
  return (
    <BrowserRouter>
      <div className="app">
        <LandingHeader />
        <Routes>
          <Route path="/" element={<LandingPage />} />
          <Route path="/platform" element={<PlatformPage />} />
          <Route path="/use-cases" element={<UseCasesPage />} />
          <Route path="/resources" element={<ResourcesPage />} />
          <Route path="/about" element={<AboutPage />} />
          <Route path="/waitlist" element={<WaitlistPage />} />
          <Route path="/product/basecalling" element={<BasecallingPage />} />
          <Route
            path="/product/standard-dna-basecalling"
            element={<BasecallingPage />}
          />
          <Route path="/product/clustering" element={<ClusteringPage />} />
          <Route
            path="/product/modification-discovery"
            element={<ModificationDiscoveryPage />}
          />
          <Route path="/product/tools" element={<ToolsPage />} />
        </Routes>
        <LandingFooter />
      </div>
    </BrowserRouter>
  );
};

export default App;
